<template>
    <div class="wrap">
      <el-card class="box-card stockCard" shadow="never">
        <el-row>
          <el-col :span="8">
            <div class="stockIndex">
              <div class="stockImg">
                <router-link :to="{name:'Stockdetailed',query:{symbol:'sh000001',isIndex:true,direction:0}}">
                  <el-image src="//image.sinajs.cn/newchart/small/nsh000001.gif"
                            style="width: 85%"></el-image>
                </router-link>
              </div>
              <p class="stockUp" v-if="indexDetail.changepercent[0]">
                <router-link :to="{name:'Stockdetailed',query:{symbol:'sh000001',isIndex:true,direction:0}}">
                  <span class="text_blue_color" >上证</span>
                </router-link>
                <span class="text_red_color" v-if="indexDetail.changepercent[0].substr(0,1) === '+'">{{ indexDetail.trade[0] }} {{ indexDetail.changepercent[0] }}% {{ indexDetail.marketCapitalization[0] }}亿元</span>
                <span class="green" v-else>{{ indexDetail.trade[0] }} {{ indexDetail.changepercent[0] }}% {{ indexDetail.marketCapitalization[0] }}亿元</span>
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stockIndex">
              <div class="stockImg">
                <router-link :to="{name:'Stockdetailed',query:{symbol:'sz399001',isIndex:true,direction:0}}">
                  <el-image src="//image.sinajs.cn/newchart/small/nsz399001.gif"
                            style="width: 85%"></el-image>
                </router-link>
              </div>
              <p class="stockUp" v-if="indexDetail.changepercent[1]">
                <router-link :to="{name:'Stockdetailed',query:{symbol:'sz399001',isIndex:true,direction:0}}">
                  <span class="text_blue_color" >深成</span>
                </router-link>
                <span class="text_red_color" v-if="indexDetail.changepercent[1].substr(0,1) === '+'">{{ indexDetail.trade[1] }} {{ indexDetail.changepercent[1] }}% {{ indexDetail.marketCapitalization[1] }}亿元</span>
                <span class="green" v-else>{{ indexDetail.trade[1] }} {{ indexDetail.changepercent[1] }}% {{ indexDetail.marketCapitalization[1] }}亿元</span>
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stockIndex">
              <div class="stockImg">
                <router-link :to="{name:'Stockdetailed',query:{symbol:'sz399415',isIndex:true,direction:0}}">
                  <el-image src="//image.sinajs.cn/newchart/small/nsz399415.gif"
                            style="width: 85%"></el-image>
                </router-link>
              </div>
              <p class="stockUp" v-if="indexDetail.changepercent[2]">
                <router-link :to="{name:'Stockdetailed',query:{symbol:'sz399415',isIndex:true,direction:0}}">
                  <span class="text_blue_color">大数据100</span>
                </router-link>
                <span class="text_red_color" v-if="indexDetail.changepercent[2].substr(0,1) === '+'">{{ indexDetail.trade[2] }} {{ indexDetail.changepercent[2] }}% {{ indexDetail.marketCapitalization[2] }}亿元</span>
                <span class="green" v-else>{{ indexDetail.trade[2] }} {{ indexDetail.changepercent[2] }}% {{ indexDetail.marketCapitalization[2] }}亿元</span>
              </p>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <div class="main">
        <el-table
          :data="tableData"
          border
          stripe
          size="mini"
          style="width: 100%">
          <el-table-column
            fixed
            align="center"
            label="代码">
            <template slot-scope="scope">
              <router-link :to="{name:'Stockdetailed',query:{symbol:scope.row.symbol,isIndex:false,direction:0}}" class="stockLinkColor">
                <span >{{ scope.row.symbol }}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            prop="name"
            label="名称">
            <template slot-scope="scope">
              <router-link :to="{name:'Stockdetailed',query:{symbol:scope.row.symbol,isIndex:false,direction:0}}" class="stockLinkColor">
                <span >{{ scope.row.name }}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="trade"
            label="最新价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="pricechange"
            label="涨跌额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="changepercent"
            label="涨跌幅">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.changepercent > 0 ? '#D02E27' : scope.row.changepercent < 0 ? '#3F7A21' : 'black' }">
                {{ scope.row.changepercent }}%
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="buy"
            label="买入">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sell"
            label="卖出">
          </el-table-column>
          <el-table-column
            align="center"
            prop="settlement"
            label="昨收">
          </el-table-column>
          <el-table-column
            align="center"
            prop="open"
            label="今开">
          </el-table-column>
          <el-table-column
            align="center"
            prop="high"
            label="最高">
          </el-table-column>
          <el-table-column
            align="center"
            prop="low"
            label="最低">
          </el-table-column>
          <!--<el-table-column
            align="center"
            width="120"
            prop="volume"
            label="成交量/手">
            <template slot-scope="scope">
              <span>{{ scope.row.volume.toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="120"
            prop="amount"
            label="成交额/万">
            <template slot-scope="scope">
              <span>{{ scope.row.amount.toLocaleString() }}</span>
            </template>
          </el-table-column>-->
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="this.pagesize">
          </el-pagination>
        </div>
      </div>
    </div>
</template>

<script>
  import $ from "jquery";
    export default {
      name: "stockrise",
      data() {
        return {
          tableData: [],
          indexDetail:{
            trade:[],
            changepercent: [],
            marketCapitalization: []
          },
          total:3809,//默认数据总数
          pagesize:15,//每页的数据条数
          currentPage:1,//默认开始页面
        };
      },
      methods: {
        getIndexData(){
          let that = this;
          let shortArr = ['s_sh000001','s_sz399001','s_sz399415'];
          $.ajax({
            url: "https://qt.gtimg.cn/q="+ shortArr.toString(),
            type: "GET",
            dataType: "script",
            cache: true,
            success: function() {
              var i, elements;
              let indexDetail = {trade:[],changepercent:[],marketCapitalization:[]};
              for (i = 0; i < shortArr.length; i++) {
                var elements = eval("v_" + shortArr[i]).split("~");
                indexDetail.trade.push(elements[3]);
                if(elements[5].substr(0,1) === '-'){
                  indexDetail.changepercent.push(elements[5]);
                }else{
                  indexDetail.changepercent.push('+'+elements[5]);
                }
                indexDetail.marketCapitalization.push((parseInt(elements[7]) / 1000).toFixed(2));
              }
              that.indexDetail = indexDetail;
            }
          });
        },
        getTableCount(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'stock_count',
            }
          })  .then(ret => {
            let resData = ret.data;
            if (resData.code === 1){
               this.total = parseInt(resData.data.count);
            }else{
              that.$alert('请稍后尝试','提示',{
                confirmButtonText: '确定',
                callback: action => that.getTableCount()
              })
            }
          });
        },
        getTableData(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'stockchange',
              'page': this.currentPage,
              'asc': 0,
              'num':15
            }
          })  .then(ret => {
            let resData = ret.data;
            if (resData.code === 1){
              this.tableData = resData.data;
              this.tableData = resData.data.filter(item => !item.symbol.startsWith('bj'));
            }else{
              that.$alert('请稍后尝试','提示',{
                confirmButtonText: '确定',
                callback: action => that.getTableData()
              })
            }
          });
        },
        //页码变更
        handleCurrentChange(currentPage) {
         this.currentPage = currentPage;
         this.getTableData();
        }
      },
      mounted: function () {
        let that = this;
        this.getIndexData();
        this.chatTimer = setInterval(function () {
          that.getIndexData();
        },10000);
        this.getTableCount();
        this.getTableData();
      },
      beforeDestroy() {
        clearTimeout(this.chatTimer);
      }
    }
</script>

<style scoped>
  .stockIndex {
    margin: 0 auto;
    text-align: center;
  }

  .stockCard {
  }

  .stockImg {
    margin: 0 auto;
  }

  .stockUp {
    line-height: 24px;
    font-size: 12px;
    width: 85%;
    height: 24px;
    background: #f3f3f5;
    text-align: center;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space: nowrap;/*加宽度width属来兼容部分浏览*/
    margin: 10px auto 0;
  }
  .main {
    margin-top: 10px;
  }
  .stockLinkColor{
    color: #0D268D;
  }
  .stockLinkColor :hover{
    color: #0D268D;
  }
  .green{
    color: #3F7A21;
  }
  .wrap{
  }

  .pagination{
    margin: 0 auto;
    text-align: center;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #D02E27 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/stockrise.vue